module.exports = __webpack_public_path__ + "0332c4e6df8aff6e8da3aec8f41b8712.svg";